var React = require('react');

function LogoFb (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#393939","fillRule":"nonzero","d":"M15.889 0C7.128 0 0 7.128 0 15.889c0 8.76 7.128 15.888 15.889 15.888 8.76 0 15.888-7.128 15.888-15.888C31.777 7.128 24.65 0 15.89 0zm3.951 16.448h-2.585v9.213h-3.83v-9.213h-1.821v-3.256h1.82v-2.107c0-1.508.717-3.865 3.866-3.865l2.839.01v3.162h-2.06c-.336 0-.813.167-.813.887v1.913h2.919l-.335 3.256z"}));
}

LogoFb.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = LogoFb;

LogoFb.default = LogoFb;
